import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  CalculatorOutlined,
  CarOutlined,
  EyeOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons'
import { Divider, Tooltip, Tag, Col, Table, Empty } from 'antd'
import { withTranslation } from 'react-i18next'
import moment from 'moment-business-days'
import DisplayIVA from '../common/DisplayIVA'
import { getRolename } from '../../lib/AuthUtils'
import { getProductImagePath, isNewProduct } from '../../lib/CatalogUtils'
import { hasDiagram } from '../../Utils/methodsUtils'
import DisplayAmount from '../common/DisplayAmount'
import Highlighter from '../common/Highlighter'
import {
  addItemToOrder,
  addItemToQuotation,
  getProductById,
  sortChange,
  showItemDetail,
  showDealModal,
} from '../../actions'
import { trackAnalyticsCommerceEvent } from '../../Utils/AnalyticsUtils'
import DisplayStock from '../common/DisplayStock'
import Favorite from '../common/Favorite'
let inc = 0

class CatalogItemsTable extends Component {
  // constructor(props) {
  //   super(props)
  // }

  // Label for Google Analytics events triggered from this component
  GA_LABEL = 'Producto - tabla grilla'

  state = {
    tableConfig: {
      bordered: false,
      loading: false,
      pagination: { position: 'bottom' },
      size: 'default',
      showHeader: true,
      locale: {
        filterTitle: 'Filtro',
        filterConfirm: 'Ok',
        filterReset: 'Cancelar',
        emptyText: 'No hay resultados',
      },
    },
  }

  openDealModal = (record, action) => {
    const payload = { showModal: true, dealItem: { ...record } }
    this.props.showDealModal(payload)
  }

  buildColumns = () => {
    const { t, onOpenDiagramModal } = this.props

    return [
      {
        title: '',
        dataIndex: 'imagesFiles',
        key: 'imagesFiles',
        width: 100,
        className: 'itemListImage',
        render: (file, record) => (
          <div
            className='productLabelContainer'
            onClick={() => {
              this.addAction(record, 'view')
            }}
          >
            {isNewProduct(record.createdAt) && (
              <span className='textLabelContent'>{t('newProduct')}</span>
            )}
            <img className='img-fluid' src={getProductImagePath(record)} />
          </div>
        ),
      },
      {
        title: t('Code'),
        dataIndex: 'codigodearticulo',
        key: 'codigodearticulo',
        sorter: true,
        width: 150,
        render: (codigodearticulo, record) => (
          <div
            onClick={() => {
              this.addAction(record, 'view')
            }}
            style={{ cursor: 'pointer' }}
          >
            <span data-testid={`product-code-${codigodearticulo}`}>{codigodearticulo}</span>
          </div>
        ),
      },
      {
        title: t('Description'),
        dataIndex: 'descripcioncatalogo',
        key: 'descripcioncatalogo',
        width: 600,
        sorter: true,
        render: (text) => (
          <div
            style={{
              width: '100%',
              whiteSpace: 'wrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {text.length > 100 ? `${text.substring(0, 100)}...` : text}
          </div>
        ),
      },
      {
        title: t('Brands'),
        dataIndex: 'marcas',
        key: 'marcas',
        width: 150,
        align: 'left',
        sorter: true,
        render: (value, obj) =>
          value[0] && (
            <Tag
              color='red'
              className='my-1'
              key={`${inc++}_${value[0].id}_${value[0].descripcion}_${new Date().getTime()}`}
            >
              {value[0].descripcion}
            </Tag>
          ),
      },
      {
        title: t('Wholesale Price'),
        dataIndex: 'preciolista',
        key: 'preciolista',
        width: 120,
        align: 'right',
        sorter: true,
        render: (text, record) => (
          <DisplayAmount amount={text} currency={record.moneda_preciolista} />
        ),
      },
      {
        title: t('Sale Price'),
        dataIndex: 'preciooferta',
        key: 'preciooferta',
        width: 120,
        align: 'right',
        sorter: true,
        render: (text, record) => (
          <DisplayAmount
            amount={this.checkDealPrice(record)}
            currency={record.moneda_preciooferta}
          />
        ),
      },
      {
        title: t('Stock'),
        dataIndex: 'semaforo',
        key: 'semaforo',
        width: 100,
        align: 'center',
        sorter: true,
        render: (value, obj) => <DisplayStock product={obj} />,
      },
      {
        title: t('VAT'),
        dataIndex: 'tipodeiva',
        key: 'tipodeiva',
        width: 80,
        align: 'center',
        render: (text) => <DisplayIVA iva={text} />,
      },
      {
        title: '',
        key: 'action',
        width: 160,
        align: 'center',
        render: (text, record) => {
          const { showEstimateBtn, showAddToCartBtn, showFavoriteBtn } = this.props
          const { t, isMobile } = this.props
          const hasDiagramResult = hasDiagram(record)
          return (
            <>
              <div className='catalog-items-table-actions actions'>
                {hasDiagramResult && (
                  <>
                    <Tooltip title={t('View diagram')} trigger={isMobile ? 'none' : 'hover'}>
                      <CarOutlined
                        onClick={() => onOpenDiagramModal(record)}
                        style={{ cursor: 'pointer' }}
                      />
                    </Tooltip>
                    <Divider type='vertical' />
                  </>
                )}
                {showFavoriteBtn && (
                  <span>
                    <Favorite product={record} GA_LABEL={this.GA_LABEL} />
                    <Divider type='vertical' />
                  </span>
                )}
                <Tooltip title={t('Detalles')}>
                  <EyeOutlined
                    data-testid='eyeAntdIcon'
                    onClick={() => {
                      this.addAction(record, 'view')
                    }}
                  />
                </Tooltip>
                {showEstimateBtn && (
                  <span>
                    <Divider type='vertical' />
                    <Tooltip title={t('Add products to quotation')}>
                      <CalculatorOutlined
                        data-testid='calculatorAntdIcon'
                        onClick={() => {
                          this.addAction(record, 'estimate')
                        }}
                      />
                    </Tooltip>
                  </span>
                )}
                {showAddToCartBtn && (
                  <span>
                    <Divider type='vertical' />
                    <Tooltip title={t('Add products to cart')}>
                      <ShoppingCartOutlined
                        data-testid='cartAntdIcon'
                        onClick={() => {
                          this.addAction(record, 'cart')
                        }}
                        style={{ marginRight: '18px' }}
                      />
                    </Tooltip>
                  </span>
                )}
              </div>
              {record && record.isInOffer && (
                <div className='mt-2'>
                  <Tag
                    color='#fe4e37'
                    style={{ borderRadius: '7px' }}
                    onClick={() => this.openDealModal(record.isInOffer)}
                  >
                    <a href='#'>{t('volumeDeal')}</a>
                  </Tag>
                </div>
              )}
            </>
          )
        },
      },
    ]
  }

  handleTableChange = (pagination, filters, sorter) => {
    const { sortChange } = this.props

    if (sorter.order) {
      let newSort

      switch (sorter.columnKey) {
        case 'preciolista':
          newSort = sorter.order === 'ascend' ? 'PR_ASC' : 'PR_DSC'
          break
        case 'codigodearticulo':
          newSort = sorter.order === 'ascend' ? 'CA_ASC' : 'CA_DSC'
          break
        case 'descripcioncatalogo':
          newSort = sorter.order === 'ascend' ? 'DC_ASC' : 'DC_DSC'
          break
        case 'marcas':
          newSort = sorter.order === 'ascend' ? 'BR_ASC' : 'BR_DSC'
          break
        case 'preciooferta':
          newSort = sorter.order === 'ascend' ? 'PO_ASC' : 'PO_DSC'
          break
        case 'semaforo':
          newSort = sorter.order === 'ascend' ? 'PS_ASC' : 'PS_DSC'
          break
        default:
          break
      }

      if (newSort) {
        sortChange(newSort)
      }
    }
  }

  addAction = (record, action) => {
    const { addItemToOrder, addItemToQuotation, user } = this.props
    const {
      id,
      codigodearticulo,
      descripcion,
      preciolista,
      tipodeiva,
      cantidadminima,
      multiplo,
      semaforo,
      semaforo_1100,
      semaforo_1200,
      semaforo_1000,
    } = record

    let quantity = 1
    if (cantidadminima && multiplo && multiplo > 0) {
      quantity =
        cantidadminima > multiplo ? Math.ceil(cantidadminima / multiplo) * multiplo : multiplo
    } else if (cantidadminima) {
      quantity = cantidadminima
    }

    // TODO hbobadilla:  Solo enviar al pai lo que realmente se necesita para esta funcionalidad.
    const itemAdd = {
      id,
      codigodearticulo,
      descripcion,
      precio: preciolista,
      cantidad: quantity,
      tipodeiva,
      observaciones: '',
      semaforo,
      semaforo_1000,
      semaforo_1100,
      semaforo_1200,
    }

    const analyticsEventParams = [
      {
        item_id: codigodearticulo,
        item_name: descripcion,
        quantity,
        price: preciolista,
      },
    ]

    const trackEvent = (action) => {
      trackAnalyticsCommerceEvent(
        action,
        this.GA_LABEL,
        codigodearticulo,
        user,
        preciolista,
        analyticsEventParams,
      )
    }

    const handleAction = (addItemAction, gaAction, itemToAdd) => {
      addItemAction({ item: itemToAdd })
      trackEvent(gaAction, user, analyticsEventParams)
    }

    const actionMap = {
      cart: () => handleAction(addItemToOrder, 'add_to_cart', itemAdd),
      estimate: () => handleAction(addItemToQuotation, 'add_to_quoter', itemAdd),
      view: () => {
        const payload = { show: true, showDealLabel: true, item: { ...record } }
        this.props.showItemDetail(payload)
        trackEvent('view_item')
      },
    }

    if (actionMap[action]) {
      actionMap[action]()
    }
  }

  checkDealPrice(product) {
    let result = null
    if (product.preciooferta) {
      const today = moment()
      if (
        product.oferta_fechafin &&
        moment(product.oferta_fechafin).isAfter(today) &&
        product.oferta_fechainicio &&
        moment(product.oferta_fechainicio).isBefore(today)
      ) {
        result = product.preciooferta
      }
    }
    return result
  }

  render() {
    const { items, onChange, rowKey, rowSelection, onRow, isMobile, t } = this.props

    // shallow copy in order to remove the image column just for this render execution
    const columns = this.buildColumns()

    // if mobile, we remove the first column (the product image) and add a custom render in order to truncate the product code
    if (isMobile) {
      columns.shift()
      columns[0].width = 100
      columns[0].render = (text, record) => (
        <Tooltip title={text}>
          <div
            onClick={() => {
              this.addAction(record, 'view')
            }}
            style={{ cursor: 'pointer' }}
          >
            <Highlighter
              terms={this.props.filter}
              text={text.length > 5 ? text.substring(0, 5) + '...' : text}
            />
          </div>
        </Tooltip>
      )
    }

    const pagination = {
      current: items.current ? items.current : 1,
      pageSize: items.pageSize ? items.pageSize : 12,
      total: items.total ? items.total : 0,
      defaultCurrent: items.current ? items.current : items.defaultCurrent || 1,
      onChange,
      showSizeChanger: false,
    }

    return (
      <Col span={24}>
        <Table
          columns={columns}
          onRow={onRow}
          rowSelection={rowSelection}
          dataSource={items.data}
          pagination={pagination}
          rowKey={rowKey}
          onChange={this.handleTableChange}
          locale={{
            emptyText: (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('No products')} />
            ),
          }}
        />
      </Col>
    )
  }
}

const mapStateToProps = ({ auth, orders, quotation, products, catalog }) => {
  const role = getRolename(auth)
  const user = auth.user
  const { current } = orders
  const currentQuotation = quotation.current
  const product = products.product
  const sortColumn = products.sort
  const { searchRequest } = catalog
  return {
    role,
    current,
    user,
    currentQuotation,
    product,
    filter: searchRequest.filter,
    sortColumn,
  }
}

export default connect(mapStateToProps, {
  addItemToOrder,
  addItemToQuotation,
  getProductById,
  sortChange,
  showItemDetail,
  showDealModal,
})(withTranslation()(CatalogItemsTable))
